module.exports = __webpack_public_path__ + "img/logo_phasi_charoen.33eecf6f.svg";